import { Divider } from '@heroui/react';
import React from 'react';
import { Controller, Control, FieldErrors } from 'react-hook-form';

import { LoginMethodRadioGroup } from '../../LoginMethodRadioGroup';
import { UserFormData } from '../hooks/useUserFormValidation';

interface LoginMethodSectionProps {
  control: Control<UserFormData>;
  errors: FieldErrors<UserFormData>;
  isEditMode?: boolean;
  disabled?: boolean;
}

export const LoginMethodSection: React.FC<LoginMethodSectionProps> = ({
  control,
  errors,
  isEditMode = false,
  disabled = false,
}) => {
  return (
    <>
      <div className="space-y-4">
        <Controller
          name="loginMethod"
          control={control}
          render={({ field }) => (
            <LoginMethodRadioGroup
              value={field.value}
              onChange={field.onChange}
              isDisabled={disabled}
              isEditMode={isEditMode}
              isRequired={true}
              errorMessage={errors.loginMethod?.message}
              data-testid="login-method-radio-group"
            />
          )}
        />
      </div>

      <Divider />
    </>
  );
};
